<template lang="pug">
#page_content.intro.page
	Banner(v-bind:item='item_banner', classes='half')
	.container.article
		img(src='~@/assets/images/intro_img.jpg')
		.row.justify-content-center: .col-sm-10
			template(v-if='$i18n.locale === "tw"')
				h5.note.text-center 2018台灣國際兒童影展開幕片《戰火下的小花》放映
				.content_outline
					p.content
						| 看電影是一種讓人難以忘懷的神奇體驗，許多現實中平凡無奇的事，透過電影鏡頭卻能讓人耳目一新，而許多天馬行空的想像，更只有在電影中才能化為真實。我們希望透過優質的影音作品，讓台灣孩童在多元文化激盪中，擴大國際視野，體會創意美感，進而深受啟發，有所領悟。
					p.content
						| 為了讓台灣兒童有機會看見世界各國最新影視作品，公共電視自2004年起，開始舉辦「台灣國際兒童影展」，是亞洲第一個專為12歲以下兒童所設立的雙年影展，規模堪稱亞洲第一。
					p.content
						| 影展中除了廣邀全世界適合兒童觀賞的優良劇情片、紀錄片、動畫片及電視節目來台觀摩放映外，也規劃國際競賽單元，以高額獎金吸引並鼓勵全球兒童影像創作者，製作富有創意、趣味與多元文化視野的作品；此外，本影展更特別設置「台灣獎」，用來鼓勵台灣在地製作團隊，協助推動國內優質影視創作發展。
					p.content
						| 此外，本影展另一項重要特色，就是「小導演大夢想工作坊」影像教育計畫。從影展創立之初，每一屆都會舉辦這個工作坊，鼓勵兒童從觀眾轉為創作者，提出拍片構想，並由主辦單位協助輔導拍攝工作，讓孩子們能夠從實做中激發潛能、培養興趣；這些孩子通力合作完成的作品，也安排在影展「小導演大夢想-台灣篇」專屬單元放映，讓他們的創意能夠被看見，從而獲得共鳴與成就感。歷屆影展中有多部作品參加國際影展並得獎，讓小朋友拍片也能站上國際舞台。
					p.content
						| 公視向來秉持公共服務精神，致力為台灣民眾提供優質的電視節目，關照各個族群。兒童是我們國家未來的希望，需要透過各種養分予以灌注。兩年一度，我們誠摯邀請大、小朋友，提供精心創作的各類兒少影像作品，和我們一起豐富這塊影展園地，讓更多兒童能夠盡情享受百花齊放的創意，一起領受我們共同創造的視覺體驗！
					h2.text-center 2022第10屆台灣國際兒童影展─線上影展
					h3.text-center 將於3月14日至4月18日舉行
			template(v-else)
				h5.note.text-center 2018 TICFF opens with The Breadwinner
				.content_outline
					p.content
						| Taiwan International Children's Film Festival (TICFF) was founded in 2004 by PTS (Public Television Service, Taiwan), aiming to provide Taiwanese children with a chance to have access to the latest creative works from around the world, exposing them to diverse cultures and broadening their international outlook.
					p.content
						| As a biennial film festival, TICFF is the biggest film festival in Taiwan as well as in Asia dedicated to children 12 years old and younger. There are 2 main parts in the Festival: international competition and Official Selection. Both competition nominated films and Official selection films, which consists of outstanding dramas, animations, documentaries and television programs created by talented filmmakers around the globe, are showcased during the event.
					p.content
						| Meanwhile, TICFF has established the “Taiwan Award” to encourage filmmakers in Taiwan to create excellent works for young audience. Another key section of the Festival is the “Kids as Directors” project, which was founded along with the first edition of the festival in 2004. This project gives young kids a chance to display their creativity, encouraging them to take the lead and create their own productions.
					p.content
						| With assistance from professionals, juvenile filmmakers attempt to produce different kinds of films. And these films are screened in a special program--“Kids as Directors Taiwanese Workshop”—during the Festival. By hosting TICFF, PTS hopes to give young generation of Taiwan a chance to view the world from diverse perspectives. We sincerely invite you to share your great works with our young audience and join us to enjoy this great series of festival events in 2022!
</template>

<script>
import Banner from '@/components/Banner.vue';
export default {
	data() {
		return {
			item_banner: {
				media: 'assets/images/banner_1.jpg',
				title: this.$t('nav_about_intro'),
			},
		};
	},
	components: {
		Banner,
	},
	watch: {
		'$i18n.locale'() {
			this.item_banner.title = this.$t('nav_about_intro');
		},
	},
};
</script>
<style lang="stylus">
#page_content.intro
	.article
		padding: 0 0 6rem 0
		img
			width: 100%
		.note
			color: $color_light
			margin: 20px 0 60px 0
		.content
			text-align: left
			color: #fff
			line-height: 2
			margin-bottom: 30px
		@media screen and (max-width: $screen-sm-max)
			.content_outline
				padding: 0 15px 0 20px
</style>
